import React, { useState } from 'react';
import { Button, Divider, Form, Input, Modal, Typography  } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '@/core/store';
import LoadingCover from '../../components/LoadingCover';
const { Text } = Typography;
const UserSignUp = ({ open, handleClose }) => {
	const 
		[ form ]            = Form.useForm(),
		dispatch            = useDispatch(),
		pending             = useSelector(state => state.auth.pending),
		loadSignUpModal     = useSelector(state => state.auth.loadSignUpModal);

	const handleSubmitSignUp = async (values) => {
		dispatch(actions.auth.submitUserSignUp(values));
	};
	const closeModal = () => {
		if(pending) {
			return false;
		}
		dispatch(actions.auth.setState({loadSignUpModal: false}));
		form.resetFields();
		handleClose();
	};
	return (
		<>
			<Modal
				title={'Request User Account'}
				visible={open}
				centered
				onCancel={closeModal}
				maskClosable={false}
				footer={null}
			>
				{
					pending &&
                <LoadingCover />
				}
				<Form
					className="ts_form_margin"
					name="submit_signup"
					form={form}
					onFinish={handleSubmitSignUp}
				>
					<Form.Item
						name="firstName"
						rules={[ { required: true, message: 'First name is required' } ]}
					>
						<Input addonBefore="First Name" className="ts_padding" disabled={pending} />
					</Form.Item>
					<Form.Item
						name="lastName"
						rules={[ { required: true, message: 'Email is required' } ]}
					>
						<Input addonBefore="Last Name" className="ts_padding" disabled={pending} />
					</Form.Item>
					<Form.Item
						name="email"
						rules={[ { required: true, message: 'Email is required' } ]}
					>
						<Input addonBefore="Email" className="ts_padding" disabled={pending} />
					</Form.Item>
					<Form.Item
						name="companyName"
						rules={[ { required: true, message: 'Company Name is required' } ]}
					>
						<Input addonBefore="Company Name" className="ts_padding" disabled={pending} />
					</Form.Item>
					<Text>Request Notes:</Text>
					<Form.Item
						name="notes"
						rules={[ { required: true, message: 'Email is required' } ]}
					>
						<Input.TextArea className="ts_padding" disabled={pending} />
					</Form.Item>
					<Divider />
					<Button
						type="primary"
						htmlType="submit"
						className="ts_margin_left"
						disabled={pending}
					>
                        Send Request
					</Button>
					<Button
						onClick={closeModal}
						className="ts_margin_left"
						disabled={pending}
					>
                        Cancel
					</Button>
				</Form>
			</Modal>
            
		</>
	);
};
export default UserSignUp;
